export enum LoadingTag {
  PURCHASE = 'purchase',
  CARGANDO_CONTENIDO = 'Cargando contenido',
}
